










































import {
  defineComponent,
  onMounted,
  ref,
  useContext,
  useRouter,
} from '@nuxtjs/composition-api';

import DiscountCodePop from '~/components/DiscountCodePop.vue';
import SelectWebsitePop from '~/components/SelectWebsitePop.vue';
import { useApi } from '~/composables/useApi';
import getSliderGql from '~/queries/getSlider.gql';
import { SliderItem } from '~/queries/types';

import getTopBarCouponCodeQuery from './getTopBarCouponCode.gql';
import TopBarCarousel from './TopBarCarousel.vue';

type TopbarObj = {
  content: string;
  coupon: string;
  link: string;
  topbar_id: string;
};
type TopbarCodeCodeQueryResponse = {
  topbar: TopbarObj;
};

export default defineComponent({
  components: {
    DiscountCodePop,
    TopBarCarousel,
    SelectWebsitePop,
  },
  props: {
    currentWebSite: {
      type: String,
      default: () => '',
    },
  },
  setup(props) {
    const isOpen = ref<Boolean>(false);

    const topbarData = ref<any>([]);

    const isOpenSelectWebsitePop = ref<Boolean>(false);
    const websiteDefaultValue = ref<any>();
    const currencyDefaultValue = ref<any>();

    const { app } = useContext();
    const { query } = useApi();
    const { isDesktop } = app.$device;
    const router = useRouter();
    const sliders = ref<any[] | null>([]);

    const fetchTopbarCodeData = async () => {
      let topBarID = [];
      if (props.currentWebSite === 'gb') {
        topBarID = ['1', '7'];
      } else if (props.currentWebSite === 'mex') {
        topBarID = ['4', '9'];
      } else {
        topBarID = ['3', '8'];
      }
      await query<TopbarCodeCodeQueryResponse>(getTopBarCouponCodeQuery, {
        id: topBarID,
      })
        .then((response) => {
          // 获取 x-client-country-code 响应头
          const clientCountryCode = app.$vsf.$magento.customData.countryCode;
          console.log('Client Country Code:', clientCountryCode);
          const countryHostMap = {
            MX: 'https://mx.unineed.com/',
            US: 'https://us.unineed.com/',
          };
          const countryCurrery = {
            MX: 'MXN',
            US: 'USD',
          };
          if (clientCountryCode && countryHostMap[clientCountryCode]) {
            if (
              window.location.href.indexOf(
                countryHostMap[clientCountryCode]
              ) === -1
            ) {
              if (
                props.currentWebSite !== 'cn' &&
                router.currentRoute.name.indexOf('home___') >= 0
              ) {
                const lastSelectWebsiteDate = localStorage.getItem(
                  '__unineed_select_website_pop'
                );
                const today = new Date().toISOString().split('T')[0];
                if (!lastSelectWebsiteDate || lastSelectWebsiteDate !== today) {
                  isOpenSelectWebsitePop.value = true;
                  localStorage.setItem('__unineed_select_website_pop', today);
                  websiteDefaultValue.value = countryHostMap[clientCountryCode];
                  currencyDefaultValue.value =
                    countryCurrery[clientCountryCode];
                }
              }
            } else if (
              props.currentWebSite !== 'cn' &&
              router.currentRoute.name.indexOf('home___') >= 0
            ) {
              const lastPopupDate = localStorage.getItem(
                '__unineed_coupon_pop'
              );
              const today = new Date().toISOString().split('T')[0];
              if (!lastPopupDate || lastPopupDate !== today) {
                isOpen.value = true;
                localStorage.setItem('__unineed_coupon_pop', today);
              }
            }
          } else if (
            props.currentWebSite !== 'cn' &&
            router.currentRoute.name.indexOf('home___') >= 0
          ) {
            const lastPopupDate = localStorage.getItem('__unineed_coupon_pop');
            const today = new Date().toISOString().split('T')[0];
            if (!lastPopupDate || lastPopupDate !== today) {
              isOpen.value = true;
              localStorage.setItem('__unineed_coupon_pop', today);
            }
          }

          // eslint-disable-next-line promise/always-return
          topbarData.value = response?.data?.topbar;
        })
        .catch((e) => {
          console.log('TopBar Error ==>', e);
        });
    };

    // CN site different
    const fetchSliderData = async () => {
      // sliderid us :11 ,cn gb: 1, mx:22
      const { data } = await query<any>(getSliderGql, { sliderId: 11 });

      if (data?.slidersData?.banners?.length > 0) {
        sliders.value = data?.slidersData?.banners as SliderItem[];
      }
    };

    const closedialog = () => {
      isOpen.value = false;
    };
    const close = () => {
      isOpenSelectWebsitePop.value = false;

      if (
        props.currentWebSite !== 'cn' &&
        router.currentRoute.name.indexOf('home___') >= 0
      ) {
        const lastPopupDate = localStorage.getItem('__unineed_coupon_pop');
        const today = new Date().toISOString().split('T')[0];
        if (!lastPopupDate || lastPopupDate !== today) {
          isOpen.value = true;
          localStorage.setItem('__unineed_coupon_pop', today);
        }
      }
    };
    const closeWebsitedialog = () => {
      isOpenSelectWebsitePop.value = false;
    };

    onMounted(async () => {
      console.log('** [Topbar.vue] ==', props.currentWebSite);
      console.log('** [Topbar.vue] is server = ', process.server);
      if (process.client && window) {
        console.log('-- client * load top bar ---');
        if (props.currentWebSite === 'cn') {
          await fetchSliderData();
        } else {
          await fetchTopbarCodeData();
        }
      } else {
        console.log('-- Server * load top bar ---');
      }
    });

    return {
      topbarData,
      isDesktop,
      sliders,
      closedialog,
      isOpen,
      isOpenSelectWebsitePop,
      close,
      closeWebsitedialog,
      websiteDefaultValue,
      currencyDefaultValue,
    };
  },
});
